var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('TabList',{attrs:{"activeTab":_vm.activeTabIndex,"customActiveTabStyle":_vm.$style.activeTab,"customNavStyle":_vm.$style.tabNav,"customTabStyle":_vm.$style.tabLink,"tabs":_vm.tabs},on:{"active-tab-change":_vm.handleActiveTabChange}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }